import { useEffect, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Clock } from 'lucide-react';

import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { formatCompactDuration } from '@/lib/formatters';
import { cn } from '@/lib/utils';

const STALE_THRESHOLD_MS = 5 * 60 * 1000; // 5 minutos

interface StaleDataBadgeProps {
  dataUpdatedAt: number;
  className?: string;
}

export function StaleDataBadge({ dataUpdatedAt, className }: StaleDataBadgeProps) {
  const { isOnline } = useOnlineStatus();

  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);

  if (!dataUpdatedAt || dataUpdatedAt <= 0) return null;

  const ageMs = now - dataUpdatedAt;
  if (ageMs < STALE_THRESHOLD_MS && isOnline) return null;

  const timeAgo = formatDistanceToNow(new Date(dataUpdatedAt), { locale: ptBR, addSuffix: true });
  const compact = formatCompactDuration(ageMs);

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-xs text-[var(--color-text-secondary)]',
        className,
      )}
      title={`Atualizado ${timeAgo}`}
    >
      <Clock size={12} aria-hidden="true" />
      <span className="hidden sm:inline">Atualizado {timeAgo}</span>
      <span className="sm:hidden">{compact}</span>
    </span>
  );
}
